// extracted by mini-css-extract-plugin
export default {"section":"Team_section__nc3fz","imageWrap":"Team_imageWrap__G7bdc","image":"Team_image__DeS0b","caption":"Team_caption__uSZ1e"};